import React from 'react'
import Homepage from './Components/Homepage';
// import "./bootstrap.min.css"
function App() {
  return (
    <div>
      {/* HomePage */}
      <Homepage />
    </div>
  );
}

export default App;
